import { LuckyCellsType } from '@libs/interfaces';
import { LuckyCells } from '@libs/interfaces';
// .07 + .07 + .07 + .03 + .07 + .03 + .07 + .07 + .07 + .07 + .07 + .07 + .07 + .07 + .03 + .07 = 1.00
export const Matrix: LuckyCells[] = [
  // Row 1
  {
    index: 0,
    type: LuckyCellsType.POINTS_10,
    probabilities: 0.0825,
    state: 'show',
  },
  {
    index: 1,
    type: LuckyCellsType.POINTS_15,
    probabilities: 0.0825,
    state: 'show',
  },
  {
    index: 2,
    type: LuckyCellsType.POINTS_20,
    probabilities: 0.0825,
    state: 'show',
  },
  {
    index: 3,
    type: LuckyCellsType.FIAT_5,
    probabilities: 0.035,
    state: 'show',
  },
  // Row 2
  {
    index: 4,
    type: LuckyCellsType.BONUS_RECHARGE_50,
    probabilities: 0.0825,
    state: 'show',
  },
  {
    index: 5,
    type: LuckyCellsType.FREE_SPIN_10,
    probabilities: 0,
    state: 'show',
  },
  {
    index: 6,
    type: LuckyCellsType.POINTS_10,
    probabilities: 0.0825,
    state: 'show',
  },
  {
    index: 7,
    type: LuckyCellsType.POINTS_10,
    probabilities: 0.0825,
    state: 'show',
  },
  // Row 3
  {
    index: 8,
    type: LuckyCellsType.FIAT_5,
    probabilities: 0.035,
    state: 'show',
  },
  {
    index: 9,
    type: LuckyCellsType.POINTS_10,
    probabilities: 0.0825,
    state: 'show',
  },
  {
    index: 10,
    type: LuckyCellsType.POINTS_10,
    probabilities: 0.0825,
    state: 'show',
  },
  {
    index: 11,
    type: LuckyCellsType.BONUS_RECHARGE_50,
    probabilities: 0.0825,
    state: 'show',
  },
  // Row 4
  {
    index: 12,
    type: LuckyCellsType.POINTS_15,
    probabilities: 0.0825,
    state: 'show',
  },
  {
    index: 13,
    type: LuckyCellsType.POINTS_10,
    probabilities: 0.0825,
    state: 'show',
  },
  {
    index: 14,
    type: LuckyCellsType.FREE_SPIN_10,
    probabilities: 0,
    state: 'show',
  },
  {
    index: 15,
    type: LuckyCellsType.POINTS_20,
    probabilities: 0.0825,
    state: 'show',
  },
];

// The sum of all probabilities is now 1.0
// (0.0825 * 12) + (0.035 * 2) = 0.99 + 0.07 = 1.0
